// import { Injectable } from '@angular/core';
// import { Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers } from '@angular/http';
// import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/catch';

// @Injectable()
// export class AuthorizedHttpService extends Http {
// 	constructor(backend: XHRBackend, options: RequestOptions) {
// 		super(backend, options)
// 	}
// 	request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
// 		let _x_auth_token = localStorage.getItem('_x_auth_token')
// 		if (_x_auth_token !== null) {
// 			if (typeof url === 'string') { // meaning we have to add the token to the options, not in url
// 				if (!options) {
// 					// let's make option object
// 					options = { headers: new Headers() }
// 				}
// 				options.headers.set('X-AUTH-TOKEN', _x_auth_token)
// 			} else {
// 				// we have to add the token to the url object
// 				url.headers.set('X-AUTH-TOKEN', _x_auth_token)
// 			}
// 		}
// 		return super.request(url, options)
// 			.catch(this.catchError(this))
// 	}
// 	private catchError(self: AuthorizedHttpService) {
// 		return (res: Response) => {
// 			return Observable.throw(res)
// 		}
// 	}
// }
import {HttpHandler, HttpInterceptor ,HttpEvent, HttpRequest} from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(){

	}
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		const tokenFromLS = localStorage.getItem('x_auth_token') ? localStorage.getItem('_x_auth_token') : 'UNAUTHORISED'; 
		const request = req.clone({
			setHeaders: {
				'X-AUTH-TOKEN': 'Bearer ' + tokenFromLS
			}
		});
		return next.handle(request)
		// throw new Error("Method not implemented.");
	}

}